export const lengthPresence = (value: string) =>
  !!(typeof value === 'string' && value.trim().length);

export const emailValidator = (value: string) => /^\S+@\S+\.\S+$/.test(value);
